import { TenantGeneralData } from './tenantGeneralData';
import { Crop } from './crop';
import { Field } from './field';

export class Parcel extends TenantGeneralData {
  name: string;
  size: number;
  sizeUnit = 'ha';
  crops: Array<Crop>;
  geoJsonArea: string;
  polygon = null;
  field: Pick<Field, 'id'> = null;
  color?: string;
  shape?: any;
  staticMapUrl: string;
  editable?: boolean; // Indicates whether the object (e.g. a polygon in a map) can be edited by the user. If true, the object is editable; if false or undefined, the object cannot be modified. See ParcelComponent
  checked?: boolean; // Indicates whether the object (e.g. a list item or checkbox) is selected. If true, the object is selected; if false or undefined, it is not selected. See SubunitCropsComponent

  constructor() {
    super();
    this.name = null;
    this.id = null;
    this.size = null;
    this.sizeUnit = 'ha';
    this.crops = [];
    this.polygon = null;
    this.geoJsonArea = null;
    this.editable = false;
    this.field = null;
    this.staticMapUrl = null;
  }
}

export const PARCELACTION = {
  EDIT: 'edit',
  DELETE: 'delete',
};
